/**
 * 返回uid
 * @return {string} uid字符串
 */
function getRandomUid() {
    let tn = new Date().getTime() + (Math.round((1 << 12) * Math.random()) << 24);
    let sn = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZXX";
    let uuid = "";

    let fn1 = sn.charAt(parseInt(tn & 63));
    tn = tn >> 6;
    let fn2 = sn.charAt(parseInt(tn & 63));
    tn = tn >> 6;
    let fn3 = sn.charAt(parseInt(tn & 63));
    tn = tn >> 6;
    let fn4 = sn.charAt(parseInt(tn & 63));
    tn = tn >> 6;
    let fn5 = sn.charAt(parseInt(tn & 63));
    tn = tn >> 6;
    let fn6 = sn.charAt(parseInt(tn & 63));
    uuid += fn6 + fn5 + fn4 + fn3 + fn2 + fn1;

    return uuid;
}

export default getRandomUid;



// WEBPACK FOOTER //
// ./components/f.component.video.auth/app/js/utils/uid.js